/*
 * Define a form page asking the user to decide if a person is in immediate danger.
 */
import css from '../../../ComplaintForm/ComplaintForm.module.css'
import { yesNoPage } from '../../../../pages/choicePage'

export const immediateDangerPage = propOverrides => {
  const props = {
    pageId: 'immediate_danger_page',
    fieldName: 'immediate_danger_yn',
    label: 'Is this person in immediate danger?',
    className: css.choices,
    labelClassName: css.largeLabel,
    ...propOverrides
  }

  return yesNoPage({ ...props })
}
